export default "__VITE_ASSET__YUxpGsXO__"